import React from "react";
import {Button} from "primereact/button";
import {formatFocusTime} from "../../pages/dashboard/focus-timer";

export default function ToolbarFocusStatus({session, elapsedSeconds = 0, translate, onOpen}) {
    const title = String(session?.task?.title || "").trim();
    const status = session?.focusSessionStatus;
    if (!title || !["running", "paused"].includes(status)) return null;

    const paused = status === "paused";
    const label = translate(paused ? "toolbar.focus.paused" : "toolbar.focus.running");
    const timer = formatFocusTime(elapsedSeconds);
    const openLabel = translate("toolbar.focus.open");
    return <Button
        type="button"
        aria-label={`${label}: ${title}، ${timer}، ${openLabel}`}
        title={`${label}: ${title}`}
        dir="rtl"
        icon={`mi mi:${paused ? "timer_play" : "timer_pause"}`}
        className={`flex align-items-center gap-2 border-none border-round-xl px-3 py-2 text-xs min-w-0 cursor-pointer ${paused ? "bg-orange-50 text-orange-700" : "bg-red-50 text-red-700"}`}
        style={{maxWidth: "20rem"}}
        onClick={onOpen}
    >
        <span className="hidden md:inline white-space-nowrap">{label}</span>
        <strong className="overflow-hidden text-overflow-ellipsis white-space-nowrap">{title}</strong>
        <span className="ltr font-bold white-space-nowrap w-3rem text-center flex-shrink-0">{timer}</span>
    </Button>;
}
